export const routes = {
  LOGIN: '/login',
  SIMULATE: '/simulate',
  ERROR: '/error',
};
